"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateInTimezone = exports.formatDate = exports.transformDecimalToTime = exports.transformTimeToDecimal = exports.transformTimeToString = exports.getDiffInHours = exports.formatHourTimespan = exports.createUTCMatchingDate = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const getAdjustedTimezone_1 = require("./helpers/getAdjustedTimezone");
/**
 * Performs timezone-safe date parsing so the dates match between UTC and any other timezone
 *
 * @param {(Date | string)} input - Date to parse
 * @return {Date}  {Date} - Parsed date
 */
function createUTCMatchingDate(input) {
    // Simple parse first
    const date = new Date(input);
    // Make it safer, consistent
    date.setUTCHours(0);
    // If the offset is negative, we need to shift the time back
    // so the dates match between UTC and any other timezone
    if (date.getTimezoneOffset() < 0) {
        const offset = date.getTimezoneOffset() * 60 * 1000;
        date.setTime(date.getTime() - offset);
    }
    // Finally, construct the date
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), 
    // We have offsets in minutes in some timezones
    // So we need to account for that
    date.getUTCMinutes());
}
exports.createUTCMatchingDate = createUTCMatchingDate;
function formatHourTimespan(timestampOne, timestampTwo, originTimezone) {
    const DATE_FORMAT = "hh:mm b";
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(originTimezone);
    const formattedTimeOne = (0, date_fns_tz_1.formatInTimeZone)(timestampOne, adjustedTimezone, DATE_FORMAT);
    const formattedTimeTwo = (0, date_fns_tz_1.formatInTimeZone)(timestampTwo, adjustedTimezone, DATE_FORMAT);
    if (formattedTimeOne === formattedTimeTwo) {
        return formattedTimeOne;
    }
    if (timestampOne > timestampTwo) {
        return `${formattedTimeTwo} - ${formattedTimeOne}`;
    }
    return `${formattedTimeOne} - ${formattedTimeTwo}`;
}
exports.formatHourTimespan = formatHourTimespan;
/*
 * Comparing 2 dates and returning diff in hours
 * Diff will be negative if date1 > date2
 */
function getDiffInHours(date1, date2) {
    const dateObject1 = new Date(date1);
    const dateObject2 = new Date(date2);
    return (dateObject2.valueOf() - dateObject1.valueOf()) / 3600000;
}
exports.getDiffInHours = getDiffInHours;
function transformTimeToString(tmpDate, with24hoursFormat = false, isUtc = true, isWithPhase = true) {
    const date = new Date(tmpDate);
    if (isUtc) {
        date.setHours(date.getUTCHours());
        date.setMinutes(date.getUTCMinutes());
    }
    const formattedTime = (0, date_fns_tz_1.format)(date, isWithPhase ? "hh:mm b" : "hh:mm");
    return formattedTime + (with24hoursFormat ? ` (${(0, date_fns_tz_1.format)(date, "HH:mm")})` : "");
}
exports.transformTimeToString = transformTimeToString;
function transformTimeToDecimal(time) {
    if (!time.includes(":")) {
        throw new Error("Invalid time format. Expected a string in 'HH:MM' format.");
    }
    const [hours, minutes] = time.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
        throw new Error("Invalid time format. Hours and minutes should be numbers.");
    }
    const decimalTime = hours + minutes / 60;
    return parseFloat(decimalTime.toFixed(2));
}
exports.transformTimeToDecimal = transformTimeToDecimal;
function transformDecimalToTime(decimalTime) {
    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);
    return `${padZero(hours)}:${padZero(minutes)}`;
}
exports.transformDecimalToTime = transformDecimalToTime;
function padZero(num) {
    return num < 10 ? "0" + num : num.toString();
}
function formatDate(date, formatString, options) {
    if (options?.timeZone) {
        options.timeZone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(options.timeZone);
    }
    return (0, date_fns_tz_1.format)(date, formatString, options);
}
exports.formatDate = formatDate;
function formatDateInTimezone(date, timezone, formatString, options) {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    return (0, date_fns_tz_1.formatInTimeZone)(date, adjustedTimezone, formatString, options);
}
exports.formatDateInTimezone = formatDateInTimezone;
//# sourceMappingURL=date-utils.js.map